import {
  TBreakdownReason,
  TFilterSelected,
  TListingFetchReason,
  TREQUEST_EDIT_BREAKDOWN_REASON,
  TRESPONSE_BREAKDOWN_REASON_LIST,
  TRESPONSE_EDIT_BREAKDOWN_REASONS_FIELD_DROPDOWN,
} from '@monorepo/types';
import { TLiftedFormModel, TUserPaginationOption } from '@monorepo/ui';
import { Action } from '@ngrx/store';
import { TBreakdownReasonsInfoActionType } from './breakdown-reasons.models';

export class GetBreakdownReasonsList implements Action {
  readonly type = TBreakdownReasonsInfoActionType.GetBreakdownReasonsList;
  constructor(public selectedFilters: TFilterSelected[], public fetchReason: TListingFetchReason) {}
}
export class GetBreakdownReasonsListSuccess implements Action {
  readonly type = TBreakdownReasonsInfoActionType.GetBreakdownReasonsListSuccess;
  constructor(public res: TRESPONSE_BREAKDOWN_REASON_LIST, public fetchReason: TListingFetchReason) {}
}

export class GetBreakdownReasonsListFailure implements Action {
  readonly type = TBreakdownReasonsInfoActionType.GetBreakdownReasonsListFailure;
}

export class GetBreakdownReasonsFilterDropDownInfo implements Action {
  readonly type = TBreakdownReasonsInfoActionType.GetBreakdownReasonsListFilterDropDown;
}

export class GetBreakdownReasonsFilterDropDownInfoSuccess implements Action {
  readonly type = TBreakdownReasonsInfoActionType.GetBreakdownReasonsListFilterDropDownSuccess;
  constructor(public dropdownRes: TRESPONSE_EDIT_BREAKDOWN_REASONS_FIELD_DROPDOWN) {}
}

export class GetBreakdownReasonsFilterDropDownInfoFailure implements Action {
  readonly type = TBreakdownReasonsInfoActionType.GetBreakdownReasonsListFilterDropDownFailure;
}

export class EditBreakdownReasons implements Action {
  readonly type = TBreakdownReasonsInfoActionType.EditBreakdownReasons;
  constructor(public payload: TREQUEST_EDIT_BREAKDOWN_REASON) {}
}

export class EditBreakdownReasonsSuccess implements Action {
  readonly type = TBreakdownReasonsInfoActionType.EditBreakdownReasonsSuccess;
}

export class EditBreakdownReasonsFailure implements Action {
  readonly type = TBreakdownReasonsInfoActionType.EditBreakdownReasonsFailure;
}

export class DeleteBreakdownReason implements Action {
  readonly type = TBreakdownReasonsInfoActionType.DeleteBreakdownReasons;
  constructor(public breakdownReasonIds: TBreakdownReason['reasonId'][]) {}
}

export class DeleteBreakdownReasonSuccess implements Action {
  readonly type = TBreakdownReasonsInfoActionType.DeleteBreakdownReasonsSuccess;
}

export class DeleteBreakdownReasonFailure implements Action {
  readonly type = TBreakdownReasonsInfoActionType.DeleteBreakdownReasonsFailure;
}

export class SetBreakdownReasonsPagination implements Action {
  readonly type = TBreakdownReasonsInfoActionType.SetBreakdownReasonsPagination;
  constructor(public pagination: TUserPaginationOption) {}
}

export type TBreakdownReasonsActions =
  | GetBreakdownReasonsList
  | GetBreakdownReasonsListSuccess
  | GetBreakdownReasonsListFailure
  | GetBreakdownReasonsFilterDropDownInfo
  | GetBreakdownReasonsFilterDropDownInfoSuccess
  | GetBreakdownReasonsFilterDropDownInfoFailure
  | EditBreakdownReasons
  | EditBreakdownReasonsSuccess
  | EditBreakdownReasonsFailure
  | DeleteBreakdownReason
  | DeleteBreakdownReasonSuccess
  | DeleteBreakdownReasonFailure
  | SetBreakdownReasonsPagination;
